import { Injectable } from '@angular/core';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class ShopAnalyticsService {
  constructor() {}

  analyticShopVisited(scenario: string) {
    let json: JSON;
    let obj: any = {
      scenario: scenario,
    };
    json = <JSON>obj;
    gtag('event', 'shop_visited', {
      event_category: 'Shop Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticShopPurchaseButtonClicked(sku: string) {
    let json: JSON;
    let obj: any = {
      sku: sku,
    };
    json = <JSON>obj;
    gtag('event', 'shop_purchase_button_clicked', {
      event_category: 'Shop Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticShopPurchaseCompleted(sku: string) {
    let json: JSON;
    let obj: any = {
      sku: sku,
    };
    json = <JSON>obj;
    gtag('event', 'shop_purchase_completed', {
      event_category: 'Shop Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticShopDiscountVisited() {
    gtag('event', 'shop_discount_visited', {
      event_category: 'Shop Events',
    });
  }

  analyticShopDiscountApplied() {
    gtag('event', 'shop_discount_applied', {
      event_category: 'Shop Events',
    });
  }
}
